import { Link } from "@inertiajs/react";
import { ArrowRight, Download } from "lucide-react";
import { Button } from "@/components/ui/button";
import PageContainer from "@/components/marketing/PageContainer";

export function GuideContents({ sections }) {
  return (
    <PageContainer width="default" className="py-4">
      <nav aria-label="On this page" className="max-w-3xl border-y border-border py-6">
        <p className="text-sm font-semibold text-foreground mb-3">On this page</p>
        <ul className="space-y-2">
          {sections.map((section, index) => (
            <li key={section.heading}>
              <a href={`#section-${index + 1}`} className="text-sm text-muted-foreground underline decoration-border underline-offset-4 hover:text-primary focus-visible:outline-primary">
                {section.heading}
              </a>
            </li>
          ))}
        </ul>
      </nav>
    </PageContainer>
  );
}

export function GuideDownload({ download, cta }) {
  return (
    <PageContainer width="default" className="pb-6">
      <div className="grid gap-5 md:grid-cols-2">
        <div className="rounded-xl border border-border bg-card p-6 md:p-8 flex flex-col items-start gap-4">
          <h2 className="text-2xl text-foreground">{download.label}</h2>
          <p className="text-muted-foreground leading-relaxed">{download.description}</p>
          <Button variant="outline" className="mt-auto" asChild>
            <a href={download.href} download>
              <Download className="h-4 w-4" /> Download the workbook
            </a>
          </Button>
          <p className="text-sm text-muted-foreground">{download.meta}</p>
        </div>
        <div className="rounded-xl bg-accent p-6 md:p-8 text-accent-foreground flex flex-col items-start gap-4">
          <h2 className="text-3xl leading-tight">{cta.heading}</h2>
          <p className="leading-relaxed">{cta.body}</p>
          <Button className="mt-auto" asChild>
            <Link href={cta.href}>
              {cta.label}<ArrowRight className="h-4 w-4" />
            </Link>
          </Button>
          {cta.secondary ? (
            <Link href={cta.secondary.href} className="text-sm underline underline-offset-4 hover:no-underline">
              {cta.secondary.label}
            </Link>
          ) : null}
        </div>
      </div>
    </PageContainer>
  );
}

export function GuideItems({ items }) {
  return (
    <ol className="mt-8 max-w-3xl space-y-7 list-decimal pl-7 marker:text-primary marker:font-semibold">
      {items.map((item) => (
        <li key={item.title} className="pl-2">
          <h3 className="text-lg font-semibold text-foreground">{item.title}</h3>
          <p className="mt-2 text-muted-foreground leading-relaxed">{item.body}</p>
        </li>
      ))}
    </ol>
  );
}

export function GuideLinks({ links }) {
  return (
    <ul className="mt-5 space-y-3 max-w-3xl">
      {links.map((link) => (
        <li key={link.href}>
          <Link href={link.href} className="inline-flex items-center gap-2 text-sm font-medium text-primary underline underline-offset-4">
            {link.label}<ArrowRight aria-hidden="true" className="h-4 w-4 shrink-0" />
          </Link>
        </li>
      ))}
    </ul>
  );
}
